import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'bv-bavel-renovating-popoup',
    templateUrl: './bavel-renovating-popoup.component.html',
    styleUrls: ['./bavel-renovating-popoup.component.scss'],
    standalone: false
})
export class BavelRenovatingPopoupComponent {
  @Output() public closePopup: EventEmitter<boolean> = new EventEmitter();
  public display = true;
  public dontShowAgain = false;

  public onClickButton(): void {
    this.closePopup.emit(this.dontShowAgain);
  }
}
